import React, { useState } from "react";
import { Dropdown, Nav, Tab } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import AuthRight from "./AuthRight";
import { loginUser } from "../../Redux/Actions/authActions";

function Signin({ loginUser }) {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        phone: "",
    });
    const [activeTab, setActiveTab] = useState("first");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
        setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            // Validate that we have the required fields
            if (activeTab === "first") {
                if (!formData.email || !formData.password) {
                    setError("Email and password are required.");
                    setLoading(false);
                    return;
                }
            } else {
                if (!formData.phone || !formData.password) {
                    setError("Phone and password are required.");
                    setLoading(false);
                    return;
                }
            }

            const credentials = activeTab === "first" 
                ? { email: formData.email.trim(), password: formData.password }
                : { phone: formData.phone.trim(), password: formData.password };

            console.log('Submitting login with credentials:', { ...credentials, password: '***' });

            const result = await loginUser(credentials);
            
            if (result.success) {
                navigate(process.env.PUBLIC_URL + "/");
            } else {
                setError(result.error || "Login failed. Please check your credentials.");
            }
        } catch (err) {
            console.error('Login error:', err);
            setError("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (<>
        <div className="body d-flex p-0 p-xl-5">
            <div className="container">
                <div className="row g-3">
                    <div className="col-lg-6 d-flex justify-content-center align-items-center auth-h100">
                        <div className="d-flex flex-column">
                            <h1>Account Login</h1>
                            <span className="text-muted">Welcome back! Log in with your Email or Phone number</span>
                            <Tab.Container defaultActiveKey="first" activeKey={activeTab} onSelect={setActiveTab}>
                                <Nav className="nav nav-pills mt-4" role="tablist">
                                    <Nav.Item className="nav-item"><Nav.Link className="nav-link" eventKey="first">Email</Nav.Link></Nav.Item>
                                    <Nav.Item className="nav-item"><Nav.Link className="nav-link" eventKey="second">Mobile</Nav.Link></Nav.Item>
                                </Nav>
                                <Tab.Content className="tab-content mt-4 mb-3" >
                                    <Tab.Pane className="tab-pane fade " id="Email" eventKey="first">
                                        <div className="card">
                                            <div className="card-body p-4">
                                                {error && (
                                                    <div className="alert alert-danger" role="alert">
                                                        {error}
                                                    </div>
                                                )}
                                                <form onSubmit={handleSubmit}>
                                                    <div className="mb-3">
                                                        <label className="form-label fs-6">Email address</label>
                                                        <input 
                                                            type="email" 
                                                            className="form-control"
                                                            name="email"
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                            required
                                                            disabled={loading}
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-label fs-6">Password</label>
                                                        <input 
                                                            type="password" 
                                                            className="form-control"
                                                            name="password"
                                                            value={formData.password}
                                                            onChange={handleChange}
                                                            required
                                                            disabled={loading}
                                                        />
                                                    </div>
                                                    <button 
                                                        type="submit" 
                                                        className="btn btn-primary text-uppercase py-2 fs-5 w-100 mt-2"
                                                        disabled={loading}
                                                    >
                                                        {loading ? "Logging in..." : "log in"}
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane className="tab-pane fade" id="Mobile" eventKey="second">
                                        <div className="card">
                                            <div className="card-body p-4">
                                                {error && (
                                                    <div className="alert alert-danger" role="alert">
                                                        {error}
                                                    </div>
                                                )}
                                                <form onSubmit={handleSubmit}>
                                                    <label className="form-label fs-6">Mobile</label>
                                                    <div className="input-group mb-3">
                                                        <input 
                                                            type="text" 
                                                            className="form-control"
                                                            name="phone"
                                                            value={formData.phone}
                                                            onChange={handleChange}
                                                            required
                                                            disabled={loading}
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-label fs-6">Password</label>
                                                        <input 
                                                            type="password" 
                                                            className="form-control"
                                                            name="password"
                                                            value={formData.password}
                                                            onChange={handleChange}
                                                            required
                                                            disabled={loading}
                                                        />
                                                    </div>
                                                    <button 
                                                        type="submit" 
                                                        className="btn btn-primary text-uppercase py-2 fs-5 w-100 mt-2"
                                                        disabled={loading}
                                                    >
                                                        {loading ? "Logging in..." : "log in"}
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                            <Link to={process.env.PUBLIC_URL + "/forgot-password"} title="#" className="text-primary text-decoration-underline">Forgot password?</Link>
                            <Link to={process.env.PUBLIC_URL + "/sign-up"} title="#" className="text-primary text-decoration-underline">Register now</Link>
                        </div>
                    </div>
                    <AuthRight />
                </div>
            </div>
        </div>
    </>
    )
}
const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, { loginUser })(Signin);